<template>
  <div>
    <div class="calendar_view_top">
      <div class="month_pager">
        <button class="prev_month" @click.prevent="prevMonth()"><</button>
        <h2>
          <strong>{{ displayMonth }}</strong> {{ displayYear }}
        </h2>
        <button class="next_month" @click.prenvet="nextMonth()">></button>
      </div>
    </div>

    <div class="calendar_month_view_container">
      <div class="month_container">
        <div class="month_row" v-for="(days, row) in allMonth" :key="row">
          <day-cell
            v-for="(day, index) in days"
            :day="day"
            :row="row"
            :key="index"
          ></day-cell>

          <div class="multi_event_list">
            <ul>
              <li
                v-for="(event, index) in multidaysEvents(days)"
                :style="calculateWidth(days, event.dateStart, event.dateEnd)"
                :key="index"
              >
                <OneEvent :event="event" :showTime="false"></OneEvent>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "./CalendarStoreEvents";
import moment from "moment";
import DayCell from "./DayCell";
import OneEvent from "./OneEvent";

export default {
  name: "calendar-month",
  components: { DayCell, OneEvent },
  data() {
    return {
      date: null,
      state: store.state,
    };
  },
  mounted() {
    this.date = moment();
  },
  computed: {
    displayMonth() {
      return moment(this.date).format("MMMM");
    },
    displayYear() {
      return moment(this.date).format("YYYY");
    },
    displayWeek() {
      let weekNum = moment(this.date).format("w");
      let currentWeek = moment().format("w");

      if (weekNum == currentWeek) {
        return "This week";
      } else {
        return "Week #" + weekNum;
      }
    },

    allMonth() {
      let startOfMonth = moment(this.date).startOf("month");
      let startOfMonthIndex = startOfMonth.weekday();
      let letStartOfMonthCalendar = startOfMonth.add(-startOfMonthIndex, "day");

      let endOfMonth = moment(this.date).endOf("month");
      let endOfMonthIndex = endOfMonth.weekday();
      let endOfMonthCalendar = 6 - endOfMonthIndex;
      endOfMonthIndex = endOfMonth.add(endOfMonthCalendar, "day");

      let days = [];
      let day = letStartOfMonthCalendar;

      while (day <= endOfMonth) {
        days.push(day.toDate());
        day = day.clone().add(1, "d");
      }

      let rows = this.chunkArray(days, 7);

      return rows;
    },
  },
  methods: {
    prevMonth() {
      this.date = moment(this.date).add(-1, "month");
    },

    nextMonth() {
      this.date = moment(this.date).add(1, "month");
    },

    chunkArray(arr, chunkSize) {
      var groups = [],
        i;
      for (i = 0; i < arr.length; i += chunkSize) {
        groups.push(arr.slice(i, i + chunkSize));
      }
      return groups;
    },
    multidaysEvents(days) {
      let dayStart = moment(days[0]);
      let dayEnd = moment(days[6]);

      console.log("couocu", days);

      return store.filterByDayMultiple(this.state.events, dayStart, dayEnd);
    },
    calculateWidth(days, start, end) {
      let dayStart = moment(days[0]);
      let dayEnd = moment(days[6]);

      let dateStart = moment(start);
      let dateEnd = moment(end);
      let width;
      let paddingStart;

      let dayToStart;
      let dayToEnd;

      if (dateStart.isSameOrBefore(dayStart)) {
        dayToStart = 0;
        paddingStart = 0;
      } else {
        dayToStart = dateStart.diff(dayStart, "days");
        paddingStart = (dayToStart / 7) * 100;
      }

      if (dateEnd.isAfter(dayEnd)) {
        dayToEnd = 0;
      } else {
        dayToEnd = dayEnd.diff(dateEnd, "days");
      }

      let eventDayLength = 7 - dayToStart - dayToEnd;

      width = (eventDayLength / 7) * 100;

      return "margin-left:" + paddingStart + "%; width: " + width + "%;";
    },
  },
};
</script>



// WEBPACK FOOTER //
// CalendarMonth.vue?7dd8aa74